import { useState, useEffect } from "react";
import { useComunicaPJe } from "../../hooks/useComunicaPJe";
import { movimentacaoProcessualService } from "../../services/movimentacaoProcessualService"; // Ajuste o caminho se necessário
import AgendaProcessoForm from "./AgendaProcessoForm";

const ProcessoModal = ({
  aberto,
  processo,
  usuarios = [],
  onSalvar,
  onFechar,
  setProcesso
}) => {
  const [mostrarAgenda, setMostrarAgenda] = useState(false);
  const [dataVencimento, setDataVencimento] = useState("");
  const [cumprido, setCumprido] = useState(false); // 🟢 Novo estado
  const [salvandoMovimentacao, setSalvandoMovimentacao] = useState(false);
  const [salvandoCumprido, setSalvandoCumprido] = useState(false);

  const movimentacao = processo?.movimentacao || processo?.ultimaMovimentacao;

  // Carrega a data de vencimento atual ao abrir o modal
  useEffect(() => {
    const dataExistente = movimentacao?.prazos?.dataVencimento;
    if (dataExistente) {
      // Converte para formato 'YYYY-MM-DD' aceito pelo input date
      const dataIso = new Date(dataExistente).toISOString().split("T")[0];
      setDataVencimento(dataIso);
    } else {
      setDataVencimento("");
    }

    // Define o valor de cumprido (verifica prazos ou nivel raiz da movimentacao)
    const statusCumprido =
      movimentacao?.prazos?.cumprido ?? movimentacao?.cumprido ?? false;
    setCumprido(Boolean(statusCumprido));
  }, [processo, movimentacao]);

  const dataNotificacao =
    movimentacao?.dataDisponibilizacao ||
    processo?.dataDisponibilizacao ||
    processo?.dataNotificacao ||
    "";

  const { textoComunicacao, loading } = useComunicaPJe(
    processo?.numeroProcesso,
    dataNotificacao,
    aberto
  );

  if (!aberto || !processo) return null;

  const obterNomeUsuario = (campoUsuario) => {
    if (!campoUsuario) return "-";
    if (typeof campoUsuario === "object" && campoUsuario.nome) {
      return campoUsuario.nome;
    }
    const id = campoUsuario.toString();
    const usuarioEncontrado = usuarios.find(
      (u) => (u._id || u.id)?.toString() === id
    );
    return usuarioEncontrado ? usuarioEncontrado.nome : "-";
  };

  const nomeAdvogado = obterNomeUsuario(processo.advogadoId);
  const nomeQuemAjuizou = obterNomeUsuario(processo.quemAjuizouId);
  const nomeParceiro = obterNomeUsuario(processo.parceiroId);

  const handleToggleAgenda = () => {
    setMostrarAgenda((prev) => !prev);
  };

  const handleSalvarMovimentacao = async () => {
    if (!movimentacao?._id) {
      alert("Nenhuma movimentação vinculada para atualizar.");
      return;
    }
    try {
      setSalvandoMovimentacao(true);
      await movimentacaoProcessualService.atualizarDataVencimento(
        movimentacao._id,
        dataVencimento,

      );
      alert("Data de vencimento da movimentação atualizada com sucesso!");
    } catch (err) {
      console.error(err);
      alert("Erro ao atualizar a data de vencimento.");
    } finally {
      setSalvandoMovimentacao(false);
    }
  };

  // 🟢 Lógica independente para atualizar o status de cumprimento diretamente no BD
  const handleAlternarCumprido = async () => {
    if (!movimentacao?._id) {
      alert("Nenhuma movimentação vinculada para atualizar.");
      return;
    }

    const novoStatus = !cumprido;

    try {
      setSalvandoCumprido(true);
      await movimentacaoProcessualService.atualizarCumprido(
        movimentacao._id,
        novoStatus
      );

      setCumprido(novoStatus);

      // Atualiza a referência no objeto local caso necessário
      if (movimentacao.prazos) {
        movimentacao.prazos.cumprido = novoStatus;
      }

      alert(`Notificação marcada como ${novoStatus ? "cumprida" : "pendente"}!`);
    } catch (err) {
      console.error(err);
      alert("Erro ao atualizar o status de cumprimento.");
    } finally {
      setSalvandoCumprido(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div
        className="modal"
        style={{
          width: "95%",
          maxWidth: "1400px",
          height: "90vh",
          overflow: "hidden"
        }}
      >
        <h2>DETALHES DO PROCESSO</h2>

        <div className="modal-content-processo">
          {/* COLUNA ESQUERDA - Texto da comunicação */}
          <div className="coluna-texto">
            <h3>
              Comunicação Processual {loading && <small>(Buscando...)</small>}
            </h3>

            <textarea
              disabled
              value={textoComunicacao}
              className="texto-comunicacao"
            />
          </div>

          {/* COLUNA DIREITA - Dados Cadastrais e Detalhes da Movimentação */}
          <div className="coluna-dados" style={{ overflowY: "auto", maxHeight: "100%" }}>
            
            {/* SEÇÃO 1: EDIÇÃO DO PROCESSO */}
            <h3>Dados do Processo</h3>
            
            <label>Número do Processo</label>
            <input disabled value={processo.numeroProcesso || ""} />

            <label>Autor / Cliente</label>
            <input disabled value={processo.autor || ""} />

            <label>Quem Ajuizou</label>
            <input disabled value={nomeQuemAjuizou} />

            <label>Advogado Responsável</label>
            <input disabled value={nomeAdvogado} />

            {processo.temParceiro && (
              <>
                <label>Advogado Parceiro</label>
                <input disabled value={nomeParceiro} />
              </>
            )}

            <label>Área do Direito</label>
            <select
              disabled
              value={processo.areaDireito || ""}
              onChange={(e) =>
                setProcesso?.({
                  ...processo,
                  areaDireito: e.target.value
                })
              }
            >
              <option value="">Selecione</option>
              <option value="Trabalhista">Trabalhista</option>
              <option value="Previdenciário">Previdenciário</option>
              <option value="Cível">Cível</option>
              <option value="Criminal">Criminal</option>
              <option value="Administrativo">Administrativo</option>
            </select>

            <label>Fase da Ação</label>
            <select
              disabled
              value={processo.faseAcao || processo.faseAtual || ""}
              onChange={(e) =>
                setProcesso?.({
                  ...processo,
                  faseAcao: e.target.value
                })
              }
            >
              <option value="">Selecione</option>
              <option value="CONCILIACAO">Audiência de Conciliação</option>
              <option value="INSTRUCAO">Instrução / Provas</option>
              <option value="SENTENCA">Sentença / Julgamento</option>
              <option value="RECURSAL">Fase Recursal</option>
              <option value="EXECUCAO">Execução / Cump. Sentença</option>
            </select>

            <hr />

            {/* SEÇÃO 2: EDIÇÃO DA MOVIMENTAÇÃO PROCESSUAL */}
            <h3>Movimentação Processual</h3>

            <p>
              <strong>Evento:</strong> {movimentacao?.evento || "-"}
            </p>

            <p>
              <strong>Tipo Especializado:</strong>{" "}
              <span className="badge-tipo">
                {movimentacao?.tipoEspecializado || processo.tipoEspecializado || "Geral"}
              </span>
            </p>

            <p>
              <strong>Urgência:</strong>{" "}
              <span className={`badge-urgencia ${movimentacao?.urgencia || processo.urgencia}`}>
                {movimentacao?.urgencia || processo.urgencia || "MEDIA"}
              </span>
            </p>

            <p>
              <strong>Órgão:</strong> {movimentacao?.orgao || "-"}
            </p>

            <p>
              <strong>Origem:</strong> {movimentacao?.origem || "-"}
            </p>

            <p>
              <strong>Data de Disponibilização:</strong>{" "}
              {movimentacao?.dataDisponibilizacao
                ? new Date(movimentacao.dataDisponibilizacao).toLocaleString("pt-BR")
                : "-"}
            </p>

            {/* Campos Editáveis do Prazo / Cumprimento */}
            <div style={{ marginTop: "12px", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "6px" }}>
              <label style={{ fontWeight: "bold", display: "block" }}>
                Data de Vencimento do Prazo:
              </label>
              <input
                type="date"
                value={dataVencimento}
                onChange={(e) => setDataVencimento(e.target.value)}
                style={{ marginTop: "4px", width: "100%", padding: "6px" }}
              />

              {/* 🟢 Botão isolado com chamada direta à API */}
              <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
                <button
                  type="button"
                  onClick={handleAlternarCumprido}
                  disabled={salvandoCumprido}
                  style={{
                    backgroundColor: cumprido ? "#28a745" : "#6c757d",
                    color: "#fff",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "4px",
                    cursor: salvandoCumprido ? "not-allowed" : "pointer",
                    fontWeight: "bold",
                    opacity: salvandoCumprido ? 0.7 : 1
                  }}
                >
                  {salvandoCumprido
                    ? "Salvando..."
                    : cumprido
                    ? "✓ Cumprido"
                    : "Marcar como Cumprido"}
                </button>
                <span style={{ fontSize: "14px", fontWeight: "bold", color: cumprido ? "#28a745" : "#888" }}>
                  {cumprido ? "Notificação Cumprida" : "Pendente"}
                </span>
              </div>
            
            {movimentacao?._id && (
              <button
                type="button"
                onClick={handleSalvarMovimentacao}
                disabled={salvandoMovimentacao}
                style={{ marginTop: "8px", padding: "6px 12px", cursor: "pointer" }}
              >
                {salvandoMovimentacao ? "Salvando Vencimento..." : "Atualizar Vencimento"}
              </button>
            )}

            <hr />

            <h3>Advogados Encontrados no PJe</h3>
            <div className="lista-advogados">
              {processo.advogados?.length > 0 ? (
                processo.advogados.map((adv, index) => (
                  <div key={index}>
                    {adv.nome}
                    <br />
                    <small>{adv.oab}</small>
                  </div>
                ))
              ) : (
                <div>Nenhum advogado encontrado</div>
              )}
            </div>

            <hr />

            <h3>Prazos</h3>
            <pre className="box-prazos">
              {processo.prazos
                ? JSON.stringify(processo.prazos, null, 2)
                : "Nenhum prazo encontrado"}
            </pre>

            {mostrarAgenda && (
              <AgendaProcessoForm
                processo={processo}
                onSucesso={() => setMostrarAgenda(false)}
                onCancelar={() => setMostrarAgenda(false)}
              />
            )}

            <div className="modal-botoes" style={{ marginTop: "20px" }}>
              {onSalvar && <button onClick={onSalvar}>Salvar Processo</button>}
              <button onClick={onFechar}>Fechar</button>
              <button
                style={{ backgroundColor: "green", marginLeft: "10px" }}
                onClick={handleToggleAgenda}
              >
                {mostrarAgenda ? "Ocultar Agenda" : "Agenda"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ProcessoModal;